import { reduxForm } from 'redux-form';
import Component from './FormSettingManualTransactionBulk';
import { validate, initialValues } from './schema';

const FormSettingManualTransactionBulk = reduxForm({
  form: 'formSettingManualTransactionBulk',
  initialValues,
  enableReinitialize: true,
  validate,
})(Component);

export default FormSettingManualTransactionBulk;
